const copyBtns = document.querySelectorAll('.copy-page, .a2a_button_copy_link');

copyBtns?.forEach(btn => {
  btn.addEventListener('click', event => {
    event.preventDefault();
    const pageURL = window.location.href;

    navigator.clipboard
      .writeText(pageURL)
      .then(() => {
        if (!btn.timer) {
          btn.timer = null;
        }

        btn.classList.add('is-copy');

        if (btn.timer) {
          clearTimeout(btn.timer);
        }

        btn.timer = setTimeout(() => {
          btn.classList.remove('is-copy');
          btn.timer = null;
        }, 1000);
      })
      .catch(err => {
        console.error('Помилка при копіюванні: ', err);
      });
  });
});

// <a href="#" class="copy-page">content</a>
